import JobRightListContainer from "../../../components/job/listing/JobRightList";

const JobRightList = () => {
  return <JobRightListContainer />;
};

export default JobRightList;
